<template>
    <div>
        <div class="flex">
            <div class="flex-1">
                <Title>{{ item.title }}</title>
                <template v-if="item.responded">
                    <span
                        v-for="response in responses"
                        :key="response.uuid"
                        class="inline-block px-2 font-semibold rounded-lg mr-1 border whitespace-no-wrap"
                        :style="{
                            'color': response.color,
                            'border-color': response.color,
                            'background-color': bgColor(response.color),
                        }"
                    >{{ response.title }}</span>

                </template>
                <template v-else>
                    &mdash;
                </template>
            </div>
            <div class="w-24 text-right text-70 ml-3">
                <template
                    v-if="
                        resource.template.display_score
                        && typeof(item.score) !== 'undefined'
                        && typeof(item.max_score) !== 'undefined'
                        && item.max_score !== 0
                        && !isOnFreePlan
                    ">
                    {{ $t('{score} points', { score: item.score }) }}
                    <!-- {{ item.max_score }} -->
                </template>
            </div>
        </div>
        <div
            v-if="item.notes"
            class="mt-3">
            <h4 class="mt-0 text-70 font-normal mb-1">{{ $t('Notes') }}:</h4>
            <div class="whitespace-pre-line">{{ item.notes }}</div>
        </div>
        <div
            v-if="item.photos && item.photos.length > 0"
            class="mt-3">
            <h4 class="mt-0 text-70 font-normal mb-1">{{ $t('Photos') }}:</h4>
            <ImageDrawing
                v-for="(photo, index) in item.photos"
                :key="photo.uuid"
                :class="{
                        'mr-3 inline-block': true,
                        'mb-3': (index + 1) !== item.photos.length
                    }"
                style="max-height: 200px;"
                :image="photo.image"
                :drawing="photo.drawing"
            />
        </div>
    </div>
</template>

<script>
    import Title from '@/components/InspectionReport/Items/Questions/Title.vue';
    import ImageDrawing from '@/components/InspectionReport/Items/Questions/ImageDrawing.vue';
    import hexadecimalToRgba from '@/util/hexadecimalToRgba';
    import OnFreePlan from '@/mixins/OnFreePlan';

    export default {
        components: { Title, ImageDrawing },
        mixins: [
            OnFreePlan,
        ],
        props: {
            item: {
                type: Object,
                required: true,
            },
            resource: {
                type: Object,
                default: null,
            },
        },
        computed: {
            responses() {
                if (this.item.response) {
                    return this.resource.form.params.response_sets
                        .find(({ uuid }) => (uuid === this.item.params.response_set))
                        .responses
                        .filter(({ uuid }) => (this.item.response.includes(uuid)));
                }
                return [];
            },
        },
        methods: {
            bgColor(hexColor) {
                return hexadecimalToRgba(hexColor);
            },
        },
    };
</script>
